import { render, staticRenderFns } from "./mints.vue?vue&type=template&id=f35b1db4&"
import script from "./mints.vue?vue&type=script&lang=js&"
export * from "./mints.vue?vue&type=script&lang=js&"
import style0 from "./mints.vue?vue&type=style&index=0&id=f35b1db4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports